import React from 'react';
import { ArrowNoStem } from '@bambuser-ui';

const Select = ({ label = null, style: overwriteStyles = {}, defaultValue, options = [], children, ...attr }) => {
  const styles = {
    select: {
      fontSize: 14,
      padding: 15,
      paddingBottom: 14,
      border: '1px solid black',
      WebkitAppearance: 'none',
      marginBottom: 14,
      backgroundColor: 'white',
      borderRadius: 0,
      width: '100%',
      paddingRight: 40,
    },
    label: {
      margin: 0,
      marginBottom: 4,
      fontSize: 9,
      fontWeight: 500,
    },
    expandIcon: {
      position: 'absolute',
      right: 14,
      top: overwriteStyles.paddingTop ? overwriteStyles.paddingTop : 13,
      pointerEvents: 'none',
    },
    container: {
      position: 'relative',
    },
  };

  return (
    <div style={styles.container}>
      {label && <p style={styles.label}>{label}</p>}
      <div style={{ position: 'relative' }}>
        <select style={{ ...styles.select, ...overwriteStyles }} defaultValue={defaultValue} {...attr}>
          {children}
        </select>
        <div style={styles.expandIcon}>
          <ArrowNoStem />
        </div>
      </div>
    </div>
  );
};

export default Select;
